import { Typography } from '../../molecules/Typography';
import { Button, ButtonProps } from '../Button';

interface iEventPageHeaderProps {
  title: string;
  subtitle?: string;
  buttonProps?: ButtonProps;
}

function EventPageHeader({
  title,
  subtitle,
  buttonProps,
}: iEventPageHeaderProps) {
  return (
    <header className='mt-8 flex flex-col items-center lg:items-center lg:justify-between gap-lg lg:flex-row'>
      <div className='flex w-full flex-col gap-xs lg:max-w-[60%]'>
        <Typography type='title' size='h2'>
          {title}
        </Typography>
        <Typography type='titleSection' size='h5'>
          {subtitle}
        </Typography>
      </div>

      {buttonProps && <Button {...buttonProps}></Button>}
    </header>
  );
}

export { EventPageHeader };
